import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ClearanceItem, CIDocument, CIImage, CIRestriction, CITag, CISignedUrl, ListSearchData, MassUpdateData } from './index';
import { AuthService, IUserInfo } from '../shared/core/index';
import { DatePipe } from '@angular/common';
import { ILookup, LookupList } from '../shared/lookup';
import 'rxjs/Rx';
import { DomSanitizer } from '@angular/platform-browser';
import { ItemHistory } from './clearance-item.model';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { find } from 'lodash';
import { SharedUtils, AppUtils } from '../shared/utils';
import { HttpService } from '../shared/core/http.service';
import { AppService } from '../app.service';

@Injectable()
export class ClearanceItemService {   


    private userInfo: IUserInfo; 

    private awsServiceAPIUrl = new URL('aws/sign', process.env.API_URL).toString();
    private lookupsAPIUrl = new URL('lookups', process.env.API_URL).toString();
    private ciServiceAPIUrl = new URL('ci', process.env.API_URL).toString();
    private ciListServiceAPIUrl = new URL('cilist', process.env.API_URL).toString();
    private historyAPIUrl = new URL('history', process.env.API_URL).toString();
    
    private _currentClearanceItem = new BehaviorSubject<ClearanceItem>(new ClearanceItem());
    CurrrentClearanceItem = this._currentClearanceItem.asObservable();

    constructor(private _http: Http, private _httpService: HttpService, private _authService: AuthService, private sanitizer: DomSanitizer, private _appService: AppService) {
        this._authService.subscribeToLoginService().subscribe(r => { this.userInfo = r });
    }

    getHistory(id: string): Observable<ItemHistory[]> {

        /* return this._http.get(this.historyUrl + '?id=' + id, {
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this._authService.accessDetails.access_token
            })
        }) */

        return this._httpService.httpGet(this.historyAPIUrl + '?id=' + id)
            .map((response: Response) => {
                return this.toHistoryItem(response)
            }
            )
            .do(data => data)
            // .catch(this.handleError);
    }

    toHistoryItem(r: any): ItemHistory[] {

        // console.log(JSON.stringify(r));
        let incomingHistories = r.json();

        var ret: ItemHistory[] = new Array<ItemHistory>();

        incomingHistories.forEach(element => {
            let h = new ItemHistory();
            h.author = element.Author;
            h.created = new Date(element.Created).toLocaleDateString();
            h.createdTime = new Date(element.Created).toLocaleTimeString();
            h.field = element.Field;
            h.id = element.Id;
            h.newValue = element.NewValue;
            h.oldValue = element.OldValue;
            ret.push(h);

        });
        return ret;
    }

    getCI(id: string, originalImages:boolean = false): Observable<ClearanceItem> {
        if (id)
            return this.getCIS(id, originalImages)
                .map((cis: ClearanceItem[]) => {   
                    // cis.forEach(ci => {
                    //     this.GetDefaultImages(ci);
                    // });
                    
                    let item = cis.find(p => p.id === id);
                    this._currentClearanceItem.next(item);

                    return item;
                })
    }

    GetDefaultImages(ci:ClearanceItem){

        const images: CIImage[] = [];

        ci.images.forEach((image) => {
            if(image.originalCIImageId === null){
                var annotations = ci.images.filter(img => img.originalCIImageId === image.id);

                if(annotations.length === 0){
                    images.push(image);
                }
            }else{
                var laterAnnotations = ci.images.filter(img => img.createdDate > image.createdDate && img.id !== image.id);

                if(laterAnnotations.length === 0){
                    var relatedImages = ci.images.filter(img => (img.originalCIImageId === image.originalCIImageId || img.id === image.originalCIImageId) && img.id !== image.id);
                    image.relatedImages = relatedImages;
                    images.push(image);
                }
            }
        });

        ci.images = images;
    }

    getCIS(id: string, originalImages:boolean = false): Observable<ClearanceItem[]> {     
        var originalImagesParameter = originalImages?"&OriginalImages=true":"";
        return this._httpService.httpGet(this.ciServiceAPIUrl + '?Id=' + id + originalImagesParameter )
            .map((response: Response) => {
                return this.mapClearanceItems(response);
            })
            .do(data => data)
            .catch(this.handleError);
    }

    getCIList(listSearchData: ListSearchData): Observable<ListSearchData> {
        
        console.log('calling getCIList() at ' + this.ciListServiceAPIUrl + ' for  ' + JSON.stringify(listSearchData));
        var body = JSON.stringify(listSearchData);
        /* return this._http.post(this.ciListServiceUrl, body, {
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this._authService.accessDetails.access_token
            })
        }) */
        return this._httpService.httpPost(this.ciListServiceAPIUrl, body)
            .map((response: Response) => {
                return this.mapListSearchData(response);
            })
            .do(data => data)
            .catch(this.handleError);
    }
    massUpdateItems(massUpdateData: MassUpdateData): Observable<boolean> {
        
        console.log('calling massUpdateItems() at ' + this.ciListServiceAPIUrl + ' for  ' + JSON.stringify(massUpdateData));
        var body = JSON.stringify(massUpdateData);
        /*return this._http.put(this.ciListServiceUrl, body, {
             headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this._authService.accessDetails.access_token
            })
        }) */
        return this._httpService.httpPut(this.ciListServiceAPIUrl, body)
            .map((response: Response) => {
                if (response.status == 200)
                    return Observable.of(true);
                else
                    return Observable.of(false);
            })
            .do(data => data)
            .catch(this.handleError);
    }

    getSignedUrl(file: string, project: string, method: string, type: string, name: string): Observable<CISignedUrl> {

        
        let paramName ='';
        if (name != ''){
            paramName = '&n=' + name;
        }
        console.log('ClearanceItemService.getSignedUrl >> Url: ' + this.awsServiceAPIUrl + '?f=' + file + '&p=' + project + paramName);
        
        return this._httpService.httpGet(this.awsServiceAPIUrl + '?f=' + file + '&p=' + project + '&m=' + method + '&t=' + type + paramName)
            .map((response: Response) => {
                //return response.text();
                return response.json();
            })
            .do(data => data)
            .catch(this.handleError);
    }

    downloadFile(url: string): Observable<Blob> {
        
        console.log('ClearanceItemService.downloadFile >> Url: ' + url);

        // return this._http.get(url, {
        //     responseType: ResponseContentType.Blob
        // }).map((data) => {
        //     return new Blob([data.blob()], {type: 'application/pdf'})
        //     // .catch(this.handleError);
        return this._http.get(url, { responseType: ResponseContentType.Blob }).map(
            (res) => {
                return new Blob([res.blob()], { type: 'application/pdf' })
            });
    }
    deleteCustomTag(ciId:string,tagId: string):Observable<boolean> {
       
       if ( !tagId) {
        console.error('cannot delete an empty Tag Id, try passing the id...');
        return Observable.of(false);
    }

    /* return this._http.delete(this.ciServiceUrl + '?CIId=' + ciId+ '&TagId=' + tagId, {
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.userInfo.accessToken
        })
    }) */
    return this._httpService.httpDelete(this.ciServiceAPIUrl + '?CIId=' + ciId+ '&TagId=' + tagId)
        .map((p: Response) => {

            console.log('deleteCustomTag');
            return Observable.of(true);
        })
        .catch((error: any) => {
              
            if (error.status === 409) {
                //return false if there is confict deleting tags.
                return Observable.of(false);
            }
            else  {
               this.handleError(error);
            }
        });
    }
    saveClearanceItem(clearanceItem: ClearanceItem): Observable<ClearanceItem> {
        
        clearanceItem.images.forEach(i => {
            i.fullUrl = '';
            i.mediumImageFullUrl = '';
            if(i.relatedImages){
                i.relatedImages.forEach(relatedImage => {
                    clearanceItem.images.push(relatedImage);
                });
            }
        })

        var i = clearanceItem.images.filter(i => i.defaultC)
        if (!i) {
            clearanceItem.images[0].defaultC = true;
        }

        //since we are not showing the flag here we set it by default.
        clearanceItem.restrictions.forEach(r => {
            if (r.description)
                r.isSelected = true;
        })

        //console.log('calling saveClearanceItem() at ' + this.ciServiceAPIUrl + ' for ci: ' + JSON.stringify(clearanceItem));

        var body = JSON.stringify(clearanceItem);

        if(body.indexOf("<") !== -1 || body.indexOf(">") !== -1){
            console.log('AntiXssMiddleware angled brackets ("<", ">") in your input(s).');
            return Observable.throw("AntiXssMiddleware");
        }

        if (!clearanceItem.id) {

            return this._httpService.httpPost(this.ciServiceAPIUrl, body)
                .map((ci: Response) => {
                    let item = this.toClearanceItem(ci.json());
                    this._currentClearanceItem.next(item);
                    return item
                })
                .catch(this.handleError);

        }
        else {

            /* return this._http.put(this.ciServiceUrl, body, {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.userInfo.accessToken
                })
            }) */
            return this._httpService.httpPut(this.ciServiceAPIUrl, body)
                .map((ci: Response) => {
                    let item = this.toClearanceItem(ci.json());
                    this._currentClearanceItem.next(item);
                    return item
                })
                .catch(this.handleError);
        }
    }

    saveClearanceItemStatus(clearanceItem: ClearanceItem): Observable<ClearanceItem> {
        console.log('calling saveClearanceItemStatus() at ' + this.ciServiceAPIUrl + ' for ci: ' + JSON.stringify(clearanceItem));
        var body = JSON.stringify(clearanceItem);

        return this._httpService.httpPatch(this.ciServiceAPIUrl, body)
            .map((ci: Response) => {
                let item = this.toClearanceItem(ci.json());
                this._currentClearanceItem.next(item);
                return item
            })
            .catch(this.handleError);
    }

    deleteClearanceItem(id: string): Observable<boolean> {

        if (!id) {
            console.error('cannot delete an empty ClearanceItem, try passing the id...');
            return Observable.of(false);
        }

        /* return this._http.delete(this.ciServiceUrl + '?CIId=' + id, {
            
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.userInfo.accessToken
            }
            )
        }) */
        return this._httpService.httpDelete(this.ciServiceAPIUrl + '?CIId=' + id)
            .map((p: Response) => {
                console.log('deleteClearanceItem');
                return Observable.of(true);
            })
            .catch(this.handleError);

    }

    searchTerm(terms: Observable<string>, projectId: string, debounceDuration = 100, type: string = 'TagSearch'): Observable<LookupList[]> {
        return terms.debounceTime(debounceDuration)
            .distinctUntilChanged()
            .switchMap(term => this.rawSearchTerm(term, projectId, type))
            .catch((e) => {
                // handle e and return a safe value or rethrow
                console.log('error on searchTag(): ' + JSON.stringify(e));
                return Observable.of<any>([]);
            });
    }

    rawSearchTerm(term: string, projectId: string, type: string = 'TagSearch'): Observable<LookupList[]> {
        console.log('rawSearchTerm()...running');
        
        let token = this._authService.accessDetails.access_token;

        var headers = new Headers({ 'Authorization': 'Bearer ' + token });

        /*Remove angle brakers to prevent XSS*/
        if(typeof term !== 'undefined'){
            if(term != null){
                term = term.replace("<","").replace(">","");
            }
        }
        
        
        /* return this._http
            .get(this.lookupsUrl + '?lookupTypes=' + type + '&searchString=' + encodeURI(term) + '&projectId=' + projectId, { headers }) */
        return this._httpService.httpGet(this.lookupsAPIUrl + '?lookupTypes=' + type + '&searchString=' + encodeURI(term) + '&projectId=' + projectId)
            .map((response) => {
                console.log(response.json());
                return <LookupList[]>response.json();
            }
            )
            .do(data => data)
            .catch(this.handleError);
    }

    mapClearanceItems(response: Response): ClearanceItem[] {
        let body = response.json();
        var ret = body.map(r => this.toClearanceItem(r));
        return ret;
    }
    mapListSearchData(response: Response): ListSearchData {
        var ret = this.toListSearchData(response.json());
        return ret;
    }
    toListSearchData(data: any): ListSearchData {
        if (data) {
            console.log(data);
            let listSearchData: ListSearchData = new ListSearchData();
            listSearchData.filterBy = data.FilterBy;
            listSearchData.filterString = data.FilterString;
            listSearchData.pageStartIndex = data.PageStartIndex;
            listSearchData.pazesize = data.Pazesize;
            listSearchData.projectId = data.ProjectId;
            listSearchData.resultSet = data.ResultSet;
            listSearchData.sortBy = data.SortBy;
            listSearchData.sortOrder = data.SortOrder;
            listSearchData.status = data.Status;
            listSearchData.totalNumberOfRecords = data.TotalNumberOfRecords;
            listSearchData.resultSet = [];
            if (data.ResultSet) {
                data.ResultSet.forEach(element => {
                    listSearchData.resultSet.push(this.toClearanceItem(element));
                });
            }
            return listSearchData;
        }
    }
    toClearanceItem(ci: any): ClearanceItem {

        // console.log('toClearanceItem where ci:' + JSON.stringify(ci));

        let clearanceItem = <ClearanceItem>
            ({
                id: ci.Id,
                name: ci.Name,
                artistAuthorName: ci.ArtistAuthorName,
                copyrightInfo: ci.CopyrightInfo,
                deadline: ci.Deadline,
                description: ci.Description,
                isCreatedByProd: ci.IsCreatedByProd,
                projectId: ci.ProjectId,
                refUrl: ci.RefUrl,
                scene: ci.Scene,
                episode: ci.Episode,
                season: ci.Season,
                status: ci.Status,
                statusChangeComments: ci.StatusChangeComments,
                ciUniqueId: ci.CIUniqueId,
                reportGroupName: ci.ReportGroupName,
                hasNotes: ci.HasNotes,
                fonts: ci.Fonts
            });

        clearanceItem.documents = new Array<CIDocument>();


        if (ci.Documents) {
            ci.Documents.forEach(element => {
                var doc: CIDocument = <CIDocument>(
                    {
                        id: element.Id,
                        name: element.Name,
                        fileType: (element.FileType ? element.FileType : 'application/octet-stream'),
                        urlName: element.UrlName,
                        defaultC: element.DefaultC,
                        dMNumber: element.DMNumber,
                        cIId: element.CIId,
                        savedId: element.Id,
                        loading: false,
                        fullUrl: element.FullUrl,
                        url: element.Url,
                        assetType: element.AssetType,
                        order: element.Order,
                    });
                clearanceItem.documents.push(doc);
            });
        }
        clearanceItem.tags = new Array<CITag>();
        if (ci.Tags) {
            ci.Tags.forEach(element => {
                var tag: CITag = <CITag>(
                    {
                        id: element.Id,
                        tagName: element.TagName,
                        tagId: element.TagId,
                        cIId: element.CIId,
                        tagType: element.TagType
                    });
                clearanceItem.tags.push(tag);
            });
            clearanceItem.tags = AppUtils.SortTags(clearanceItem.tags);
        }
        clearanceItem.restrictions = new Array<CIRestriction>();
        if (ci.Restrictions) {
            ci.Restrictions.forEach(element => {
                var restriction: CIRestriction = <CIRestriction>(
                    {
                        id: element.Id,
                        restrictionType: element.RestrictionType,
                        description: element.Description,
                        cIId: element.CIId
                    });
                clearanceItem.restrictions.push(restriction);
            });
        }
        clearanceItem.images = new Array<CIImage>();
        clearanceItem.imagesRef = new Array<CIImage>();

        if (ci.Images) {
            ci.Images.forEach(element => {
                var ciImage: CIImage = <CIImage>(
                    {
                        id: element.Id,
                        fileType: (element.FileType ? element.FileType : 'application/octet-stream'),
                        urlName: element.UrlName,
                        name: element.Name,
                        defaultC: element.DefaultC,
                        showOnReports: element.ShowOnReports,
                        cIId: element.CIId,
                        fullUrl: element.FullUrl,
                        url: element.Url,
                        savedId: element.Id,
                        assetType: element.AssetType ? element.AssetType : 'Image',
                        order: element.Order,
                        highlighted : element.Highlighted,
                        font: element.Font,
                        usage: element.Usage,
                        tag: element.Tag,
                        notes: element.Notes,
                        comments: element.Comments,
                        originalCIImageId: element.OriginalCIImageId,
                        lastModifiedDate: element.LastModifiedDate,
                        createdDate: element.CreatedDate,
                        originalFullUrl: element.OriginalFullUrl,
                        thumbnailFullUrl: element.ThumbnailFullUrl,
                        mediumImageFullUrl: element.MediumImageFullUrl
                    });
                ciImage.relatedImages = new Array<CIImage>();
                if (element.RelatedImages) {
                    element.RelatedImages.forEach(relatedImage => {
                        var rImage: CIImage = <CIImage>(
                            {
                                id: relatedImage.Id,
                                fileType: (relatedImage.FileType ? relatedImage.FileType : 'application/octet-stream'),
                                urlName: relatedImage.UrlName,
                                name: relatedImage.Name,
                                defaultC: relatedImage.DefaultC,
                                showOnReports: relatedImage.ShowOnReports,
                                cIId: relatedImage.CIId,
                                fullUrl: relatedImage.FullUrl,
                                url: relatedImage.Url,
                                savedId: relatedImage.Id,
                                assetType: relatedImage.AssetType ? relatedImage.AssetType : 'Image',
                                highlighted : relatedImage.Highlighted,
                                font: relatedImage.Font,
                                usage: relatedImage.Usage,
                                tag: relatedImage.Tag,
                                notes: relatedImage.Notes,
                                originalCIImageId: relatedImage.OriginalCIImageId,
                                lastModifiedDate: relatedImage.LastModifiedDate,
                                createdDate: relatedImage.CreatedDate,
                                originalFullUrl: relatedImage.OriginalFullUrl,
                                thumbnailFullUrl: relatedImage.ThumbnailFullUrl,
                                mediumImageFullUrl: relatedImage.MediumImageFullUrl
                            });
                        ciImage.relatedImages.push(rImage);
                    })
                }
                clearanceItem.images.push(ciImage);    
            });
            
        }
        clearanceItem.titles = new Array<ILookup>();
        if (ci.Titles){
            ci.Titles.forEach(element => {
                var title:ILookup =<ILookup>({
                    id: element.id,
                    name: element.name,
                    type: element.type,
                    isDefault: element.isDefault,
                    order: element.order
                });
                clearanceItem.titles.push(title);
            });
        }

        // console.log('returning: ' + JSON.stringify(clearanceItem));
        return clearanceItem;
    }


    getFilters(): any {
        return {};
    }

    private handleError(error: Response) {
        // console.error('error!:' + error.json() ? error.json() : error.text);
        return Observable.throw(error || 'Server error');
    }

    public getOriginalImagesFullUrls(CI: ClearanceItem): Observable<CISignedUrl>[]{
        
        return CI.images.filter(image => SharedUtils.FileTypeIsImage(image.fileType) || image.fileType.endsWith('pdf'))
            .map(image => {
            return this._appService.getSignedUrlInline(image.url, CI.projectId,'GET','image','ci',image.urlName);        
        });
    }

    postCreateOptimizedImages(id: string): void {
        console.log('calling CreateOptimizedImages() at ' + this.ciServiceAPIUrl + ' for  ' + id);
        this._httpService.httpPost(this.ciServiceAPIUrl+"/CreateOptimizedImages?Id="+id, "")
            .subscribe(
                data => {
                    console.log('CreateOptimizedImages result:', data);
                },
                error => {
                    console.error('CreateOptimizedImages error:', error);
                }
            );
    }


    postSendFtrackNotificacion(id: string): void {
        console.log('calling SendFtrackNotificacion() at ' + this.ciServiceAPIUrl + ' for  ' + id);
        var body =  `"${id}"`;
        this._httpService.httpPost(this.ciServiceAPIUrl+"/SendFtrackNotificacion", body)
            .subscribe(
                data => {
                    console.log('FtrackNotificacion result:', data);
                },
                error => {
                    console.error('FtrackNotificacion error:', error);
                }
            );
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/clearance-item.service.ts